import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import ajaxPurchaseOrders from "../../util/remote/ajaxPurchaseOrders";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ajaxDeliveryNotes from "../../util/remote/ajaxDeliveryNotes";
const CreateDeliveryNote = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [orderID, setOrderID] = useState("");
  const [delievery_reff_no, setDelieveryReffNo] = useState("");
  const [comment, setComment] = useState("");
  const [Delivered_by, setDelivered_by] = useState("");
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // YYYY-MM-DD local
  });
  const [goodsReceivedNo, setGoodsReceivedNo] = useState("");
  // Rows state
  const [rows, setRows] = useState([]);
  // PurchaseOrders
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const fetchPurchaseOrder_mini_data = async () => {
    const server_response =
      await ajaxPurchaseOrders.fetchPurchaseOrderMini_data({});
    if (server_response.status === "OK") {
      setPurchaseOrder(
        Array.isArray(server_response.details)
          ? server_response.details
          : PurchaseOrder
      );
    } else {
      setPurchaseOrder([]);
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchPurchaseOrder_mini_data();
  }, []);
  // Fetch order items
  const [requisitionsItems, setRequisitionsItems] = useState([]);
  const fetchingRequisitionItems = async () => {
    if (!orderID) {
      setRows([]);
      return;
    }
    const server_response = await ajaxPurchaseOrders.fetchPurchaseOrderItems({
      orderID: orderID,
    });
    if (server_response.status === "OK") {
      setRequisitionsItems(
        Array.isArray(server_response.details) ? server_response.details : []
      );
    } else {
      setRequisitionsItems([]);
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchingRequisitionItems();
  }, [orderID]);
  // Populate rows from requisition items
  useEffect(() => {
    if (requisitionsItems.length > 0) {
      const mappedRows = requisitionsItems.map((item) => ({
        id: item.id,
        orderID: item.orderID,
        item_name: item.item_name,
        quantity: Number(item.quantity),
        unit: item.unit || "",
        delivered: false,
        delivered_qty: 0,
      }));
      setRows(mappedRows);
    } else {
      setRows([]);
    }
  }, [requisitionsItems]);
  // Handle changes
  const handleDeliveredChange = (index, checked) => {
    const updatedRows = [...rows];
    updatedRows[index].delivered = checked;
    updatedRows[index].delivered_qty = checked
      ? updatedRows[index].quantity
      : 0;
    setRows(updatedRows);
  };
  const handleDeliveredQtyChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].delivered_qty = Number(value);
    setRows(updatedRows);
  };
  const allRowsFilled = () =>
    orderID &&
    rows.length > 0 &&
    rows
      .filter((r) => r.delivered)
      .every((row) => row.delivered_qty && row.delivered_qty > 0);
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please enter delivered quantity for all selected items");
      return;
    }
    const deliveredItems = rows
      .filter((r) => r.delivered)
      .map((row) => ({
        id: row.id,
        orderID: row.orderID,
        item_name: row.item_name,
        quantity: String(row.delivered_qty), // use delivered quantity if needed as string
      }));
    const data = {
      orderID: Number(orderID),
      delievery_reff_no: delievery_reff_no,
      good_recieved_no: goodsReceivedNo,
      date_created: dateCreated,
      comment: comment,
      recieved_byID: userId,
      Delivered_by: Delivered_by,
      order_items: deliveredItems,
    };
    setLoading(true);
    const response = await ajaxDeliveryNotes.createDeliveryNotee(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setOrderID("");
    setDelieveryReffNo("");
    setComment("");
    setRows([]);
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  return (
    <AppContainer title="Create Delivery Note">
      <div className="container-fluid">
        <Toaster />
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/delievery_notes/view")}
            >
              View Delivery Notes
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Create Delivery Note</h6>
                <form onSubmit={handleAdd}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="col-md-12">
                        <label>
                          Select Purchase Order
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          onChange={(e) => setOrderID(e?.orderID)}
                          getOptionLabel={(option) =>
                            option.reff_naration || ""
                          }
                          getOptionValue={(option) => option.orderID || ""}
                          isSearchable
                          options={
                            Array.isArray(PurchaseOrder) ? PurchaseOrder : []
                          }
                          value={
                            Array.isArray(PurchaseOrder)
                              ? PurchaseOrder.find(
                                  (value) => value.orderID === orderID
                                ) || null
                              : null
                          }
                          placeholder="Select Requisition"
                        />
                      </div>
                      <div className="col-md-12">
                        <label>
                          Delivered By <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={Delivered_by}
                          onChange={(e) => setDelivered_by(e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>
                          Delivery Number{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Delivery_no"
                          value={delievery_reff_no}
                          onChange={(e) => setDelieveryReffNo(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group col-md-12">
                        <label>
                          Goods recieved Number{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Goods recieved Number"
                          value={goodsReceivedNo}
                          onChange={(e) => setGoodsReceivedNo(e.target.value)}
                        />
                      </div>
                      <div className="col-md-12">
                        <label>
                          Date Created <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={dateCreated}
                          onChange={(e) => setDateCreated(e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-12">
                      <p className="">Comment</p>
                      <textarea
                        className="form-control"
                        placeholder="comment"
                        rows="2"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                  {/* Items Table */}
                  <div className="mb-4 col-md-12">
                    <table className="table table-bordered table-hover text-nowrap mg-b-0">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Item Name</th>
                          <th>Quantity</th>
                          <th>Unit</th>
                          <th>Delivered</th>
                          <th>Quantity Delivered</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                value={row.item_name}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="number"
                                value={row.quantity}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                value={row.unit}
                                readOnly
                              />
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={row.delivered}
                                onChange={(e) =>
                                  handleDeliveredChange(index, e.target.checked)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="number"
                                min={0}
                                max={row.quantity}
                                value={row.delivered_qty}
                                disabled={!row.delivered}
                                onChange={(e) =>
                                  handleDeliveredQtyChange(
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-center col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-success col-lg-12"
                      disabled={!allRowsFilled() || loading}
                    >
                      {loading ? <Loader /> : "Submit Delivery Note"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default CreateDeliveryNote;
